var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinterestIconTransparency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "25px",
    height: "25px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.24,-10.24) scale(1.08,1.08)"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    fill: "#dddddd",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48148,246.51852v-237.03704h237.03704v237.03704z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    fill: "#100202",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128,235.85185c-59.56493,0 -107.85185,-48.28692 -107.85185,-107.85185v0c0,-59.56493 48.28692,-107.85185 107.85185,-107.85185h0c59.56493,0 107.85185,48.28692 107.85185,107.85185v0c0,59.56493 -48.28692,107.85185 -107.85185,107.85185z",
    id: "shape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#735741",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,2c-12.6907,0 -23,10.3093 -23,23c0,12.69071 10.3093,23 23,23c12.69071,0 23,-10.30929 23,-23c0,-12.6907 -10.30929,-23 -23,-23zM25,4c11.60983,0 21,9.39017 21,21c0,11.60983 -9.39017,21 -21,21c-2.12364,0 -4.17229,-0.31786 -6.10352,-0.90234c0.86025,-1.43824 1.97086,-3.49407 2.41211,-5.19141c0.26213,-1.00636 1.33984,-5.11133 1.33984,-5.11133c0.7004,1.33714 2.74684,2.46875 4.92578,2.46875c6.4839,0 11.1582,-5.96299 11.1582,-13.37305c0,-7.1041 -5.79701,-12.41797 -13.25586,-12.41797c-9.27973,0 -14.20508,6.22817 -14.20508,13.00977c0,3.15388 1.67744,7.07977 4.36328,8.33008c0.40684,0.18937 0.62531,0.10733 0.71875,-0.28711c0.07194,-0.29935 0.43475,-1.7586 0.59766,-2.4375c0.0521,-0.21665 0.02687,-0.40384 -0.14844,-0.61719c-0.88894,-1.0783 -1.60156,-3.0589 -1.60156,-4.90625c0,-4.74241 3.59028,-9.33203 9.70703,-9.33203c5.28156,0 8.98047,3.60045 8.98047,8.74805c0,5.81575 -2.9366,9.8457 -6.75781,9.8457c-2.11031,0 -3.6905,-1.74581 -3.18359,-3.88672c0.60779,-2.55519 1.78125,-5.31251 1.78125,-7.1582c0,-1.65054 -0.88576,-3.02734 -2.7207,-3.02734c-2.15744,0 -3.89062,2.23055 -3.89062,5.2207c0,1.90275 0.64453,3.19141 0.64453,3.19141c0,0 -2.13118,9.0105 -2.52148,10.6875c-0.39114,1.67579 -0.28638,3.93285 -0.125,5.61328c-7.6941,-3.11433 -13.11523,-10.64747 -13.11523,-19.4668c0,-11.60982 9.39017,-21 21,-21z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIconTransparency);
export default __webpack_public_path__ + "static/media/pinterest-icon-transparency.0694872b77bbbd0f61c4ddae7b8c6212.svg";
export { ForwardRef as ReactComponent };